/**
 * MechaGuard - 防御塔注册表
 *
 * 把 5 种塔的类与元数据集中导出，UI（建造菜单/信息面板）与
 * 游戏逻辑（创建实例）都从这里取数据，避免散落的硬编码。
 */

import { LaserTower } from './LaserTower.js';
import { CryoTower } from './CryoTower.js';
import { PlasmaTower } from './PlasmaTower.js';
import { TeslaTower } from './TeslaTower.js';
import { RailgunTower } from './RailgunTower.js';
import { MissileTower } from './MissileTower.js';

/** id -> 类 */
export const TOWER_CLASSES = Object.freeze({
  laser: LaserTower,
  cryo: CryoTower,
  plasma: PlasmaTower,
  tesla: TeslaTower,
  railgun: RailgunTower,
  missile: MissileTower,
});

/** 建造菜单中的显示顺序 */
export const TOWER_ORDER = Object.freeze(['laser', 'cryo', 'plasma', 'tesla', 'railgun', 'missile']);

/**
 * 供 UI 使用的塔类型列表（含 Class 引用）
 * @type {{id:string,name:string,icon:string,cost:number,desc:string,color:string,Class:Function}[]}
 */
export const TOWER_TYPES = TOWER_ORDER.map(id => {
  const Class = TOWER_CLASSES[id];
  return { ...Class.META, Class };
});

/**
 * 按 id 取元数据
 * @param {string} id
 */
export function getTowerMeta(id) {
  return TOWER_TYPES.find(t => t.id === id) || null;
}

/**
 * 创建一个塔实例
 * @param {string} id
 * @param {number} col
 * @param {number} row
 */
export function createTower(id, col, row) {
  const Class = TOWER_CLASSES[id];
  if (!Class) throw new Error(`未知的防御塔类型: ${id}`);
  return new Class(col, row);
}
